var _defs, _metadata, _rect, _g, _path, _path2, _path3, _g2, _path4, _g3, _circle, _g4, _circle2, _circle3, _circle4, _rect2, _line, _line2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAni15(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "77.2523mm",
    height: "62.5082mm",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 1027 831",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n    .str0 {stroke:black;stroke-width:23.4582}\r\n    .str1 {stroke:black;stroke-width:23.4582;stroke-linecap:round;stroke-linejoin:round}\r\n    .fil0 {fill:none}\r\n    .fil6 {fill:black}\r\n    .fil3 {fill:gray}\r\n    .fil2 {fill:#E6E6E6}\r\n    .fil7 {fill:#F2C2CA}\r\n    .fil1 {fill:#F6C748}\r\n    .fil5 {fill:white}\r\n    .fil4 {fill:white;fill-rule:nonzero}\r\n  "), /*#__PURE__*/React.createElement("clipPath", {
    id: "id0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M514 155c-33,0 -224,7 -334,243 -133,286 116,322 334,321 218,0 466,-34 333,-321 -110,-236 -300,-243 -333,-243z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Capa_x0020_1"
  }, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_211464400"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "fil0",
    width: 1027,
    height: 831
  })), /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil1 str0",
    d: "M400 269c-104,-26 -103,-123 -132,-121 -29,1 -66,90 41,159 44,-17 91,-38 91,-38z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1 str0",
    d: "M627 269c104,-26 103,-123 132,-121 29,1 66,90 -40,159 -44,-17 -92,-38 -92,-38z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "fil2 str0",
    d: "M703 274c0,0 204,0 255,100 7,12 15,29 -12,42 -26,13 -151,10 -181,-3 -31,-14 -62,-139 -62,-139z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "fil3 str0",
    d: "M324 274c0,0 -203,0 -255,100 -6,12 -14,29 12,42 26,13 151,10 182,-3 30,-14 61,-139 61,-139z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "fil2",
    d: "M514 155c-33,0 -224,7 -334,243 -133,286 116,322 334,321 218,0 466,-34 333,-321 -110,-236 -300,-243 -333,-243z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#id0)"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "fil3",
    cx: 353,
    cy: 203,
    rx: 137,
    ry: 152
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "fil3",
    cx: 693,
    cy: 470,
    rx: 146,
    ry: 163
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "fil3",
    cx: 216,
    cy: 662,
    rx: 106,
    ry: 108
  })))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "fil0 str0",
    d: "M514 155c-33,0 -224,7 -334,243 -133,286 116,322 334,321 218,0 466,-34 333,-321 -110,-236 -300,-243 -333,-243z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil4",
    d: "M453 483l-47 0 0 0 0 -2 0 -3 -1 -2 0 -2 0 -2 -1 -2 0 -1 -1 -2 -1 -2 -1 -2 -1 -1 0 -2 -1 -2 -2 -1 -1 -2 -1 -1 -1 -1 -1 -1 -2 -1 -1 -1 -1 -1 -2 -1 -1 -1 -2 -1 -1 0 -2 -1 -1 0 -2 -1 -1 0 -2 0 -1 -1 -2 0 0 -47 4 1 4 0 5 1 4 0 4 1 4 2 3 1 4 2 4 1 3 2 4 2 3 3 3 2 3 3 3 3 3 2 2 4 3 3 2 3 2 3 2 4 2 3 2 4 1 4 2 4 1 4 1 4 1 4 1 4 0 4 0 4 1 5 0 0zm-81 86l0 -47 0 0 2 0 1 0 2 0 1 -1 2 0 1 -1 2 0 1 -1 2 0 1 -1 2 -1 1 -1 1 -1 2 -1 1 -1 1 -2 1 -1 1 -2 2 -1 1 -2 0 -1 1 -2 1 -2 1 -1 1 -2 0 -2 1 -2 0 -2 0 -2 1 -2 0 -2 0 -2 47 0 -1 4 0 4 0 4 -1 5 -1 4 -1 4 -1 4 -2 4 -1 3 -2 4 -2 4 -2 3 -2 3 -2 4 -3 3 -2 3 -3 3 -3 3 -3 2 -3 3 -3 2 -4 2 -3 2 -4 2 -4 1 -3 2 -4 1 -4 1 -4 1 -5 0 -4 1 -4 0 0 0zm-81 -86l47 0 0 0 0 2 0 2 1 2 0 2 0 2 1 2 0 2 1 2 1 1 1 2 1 2 1 1 1 2 1 1 1 2 1 1 1 2 1 1 2 1 1 1 1 1 2 1 1 1 2 0 1 1 2 0 1 1 2 0 1 1 2 0 1 0 2 0 0 47 -4 0 -4 -1 -5 0 -4 -1 -4 -1 -4 -1 -3 -2 -4 -1 -4 -2 -3 -2 -4 -2 -3 -2 -3 -3 -3 -2 -3 -3 -3 -3 -2 -3 -3 -3 -2 -4 -2 -3 -2 -3 -2 -4 -2 -4 -1 -3 -2 -4 -1 -4 -1 -4 -1 -4 -1 -5 0 -4 0 -4 -1 -4 0 0zm81 -87l0 47 0 0 -2 0 -1 1 -2 0 -1 0 -2 1 -1 0 -2 1 -1 0 -2 1 -1 1 -2 1 -1 1 -1 1 -2 1 -1 1 -1 1 -1 1 -1 2 -1 1 -1 2 -1 2 -1 1 -1 2 -1 2 -1 2 0 1 -1 2 0 2 0 2 -1 2 0 3 0 2 -47 0 1 -5 0 -4 0 -4 1 -4 1 -4 1 -4 1 -4 2 -4 1 -4 2 -4 2 -3 2 -4 2 -3 2 -3 3 -3 2 -4 3 -2 3 -3 3 -3 3 -2 3 -3 4 -2 3 -2 4 -1 4 -2 3 -1 4 -2 4 -1 4 0 5 -1 4 0 4 -1 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: 1,
    className: "fil5",
    d: "M372 420c32,0 57,28 57,63 0,34 -25,62 -57,62 -32,0 -57,-28 -57,-62 0,-35 25,-63 57,-63z"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "fil6",
    cx: 388,
    cy: 484,
    r: 52
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil4",
    d: "M575 483l0 0 0 -5 0 -4 1 -4 0 -4 1 -4 1 -4 2 -4 1 -4 2 -4 1 -4 2 -3 2 -4 2 -3 3 -3 2 -3 3 -4 3 -2 2 -3 3 -3 4 -2 3 -3 3 -2 4 -2 3 -1 4 -2 4 -1 4 -2 4 -1 4 0 4 -1 4 0 4 -1 0 47 -1 0 -2 1 -1 0 -2 0 -2 1 -1 0 -2 1 -1 0 -1 1 -2 1 -1 1 -2 1 -1 1 -1 1 -2 1 -1 1 -1 1 -1 2 -1 1 -1 2 -1 2 -1 1 -1 2 0 2 -1 2 -1 1 0 2 -1 2 0 2 0 2 0 3 0 2 0 0 -47 0zm80 86l0 0 -4 0 -4 -1 -4 0 -4 -1 -4 -1 -4 -1 -4 -2 -4 -1 -3 -2 -4 -2 -3 -2 -3 -2 -4 -3 -3 -2 -2 -3 -3 -3 -3 -3 -2 -3 -3 -4 -2 -3 -2 -3 -2 -4 -1 -4 -2 -3 -1 -4 -2 -4 -1 -4 -1 -4 0 -5 -1 -4 0 -4 0 -4 47 0 0 2 0 2 0 2 0 2 1 2 0 2 1 2 1 2 0 1 1 2 1 2 1 1 1 2 1 1 1 2 1 1 1 2 2 1 1 1 1 1 2 1 1 1 2 1 1 0 1 1 2 0 1 1 2 0 2 1 1 0 2 0 1 0 0 0 0 47zm81 -86l0 0 0 4 0 4 -1 4 -1 5 0 4 -1 4 -2 4 -1 4 -2 3 -1 4 -2 4 -2 3 -2 3 -3 4 -2 3 -3 3 -3 3 -3 3 -3 2 -3 3 -3 2 -3 2 -4 2 -4 2 -3 1 -4 2 -4 1 -4 1 -4 1 -4 0 -4 1 -5 0 0 -47 2 0 2 0 1 0 2 -1 1 0 2 -1 1 0 2 -1 1 0 2 -1 1 -1 1 -1 2 -1 1 -1 1 -1 2 -2 1 -1 1 -2 1 -1 1 -2 1 -1 1 -2 1 -2 0 -1 1 -2 1 -2 0 -2 0 -2 1 -2 0 -2 0 -2 0 -2 0 0 47 0zm-81 -87l0 0 5 1 4 0 4 1 4 0 4 1 4 2 4 1 3 2 4 1 4 2 3 2 3 3 3 2 3 3 3 3 3 2 3 4 2 3 3 3 2 3 2 4 2 3 1 4 2 4 1 4 2 4 1 4 0 4 1 4 1 4 0 4 0 5 -47 0 0 -2 0 -3 0 -2 -1 -2 0 -2 0 -2 -1 -1 -1 -2 0 -2 -1 -2 -1 -1 -1 -2 -1 -2 -1 -1 -1 -2 -1 -1 -2 -1 -1 -1 -1 -1 -2 -1 -1 -1 -1 -1 -2 -1 -1 -1 -2 0 -1 -1 -2 0 -1 -1 -2 0 -1 0 -2 -1 -2 0 0 0 0 -47z"
  }), /*#__PURE__*/React.createElement("path", {
    id: 1,
    className: "fil5",
    d: "M655 420c-31,0 -57,28 -57,63 0,34 26,62 57,62 32,0 58,-28 58,-62 0,-35 -26,-63 -58,-63z"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "fil6",
    cx: 640,
    cy: 484,
    r: 52
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "fil5",
    cx: 624,
    cy: 483,
    r: 20
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "fil5",
    cx: 403,
    cy: 483,
    r: 20
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "fil7 str0",
    x: 372,
    y: 531,
    width: 283,
    height: 220,
    rx: 54,
    ry: 72
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "fil0 str1",
    x1: 461,
    y1: 698,
    x2: 461,
    y2: 630
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "fil0 str1",
    x1: 566,
    y1: 698,
    x2: 566,
    y2: 630
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAni15);
export default __webpack_public_path__ + "static/media/ani15.15a8b203e72d65ce486e744e8d30dd27.svg";
export { ForwardRef as ReactComponent };